import { useMutation } from "@apollo/client"
import CustomButton from "components/Atoms/CustomButton"
import StaticSelector from "components/Atoms/StaticSelector"
import FormController from "components/Molecules/FormController"
import { DELETE_SURVEY_AREA } from "graphql/survey-areas/survey-areas.mutations.gql"
import { uniqueId } from "lodash-es"
import React, { useEffect, useState } from "react"
import { generateId } from "utils/custom.utils"
import useDCStore from "../dc.store"
import FormLayout from "../FormLayout"
import SurveyAreaRegistration from "./SurveyAreaRegistration"

const DCSurveyAreaList = () => {
  const { surveyAreas, onChange, onAdd, onRemove } = useDCStore(store => ({
    surveyAreas: store.state.surveyAreas,
    onChange: store.setData("surveyAreas"),
    onAdd: store.addListItem,
    onRemove: store.removeListItem,
  }))

  const [selectedSurveyArea, setSelectedSurveyArea] = useState<any>()

  useEffect(() => {
    if (surveyAreas?.length > 0 && !selectedSurveyArea) {
      setSelectedSurveyArea(surveyAreas[0])
    }
    if (surveyAreas?.length > 0 && selectedSurveyArea?.id) {
      setSelectedSurveyArea(
        surveyAreas?.find(area => area.id === selectedSurveyArea?.id)
      )
    }
  }, [surveyAreas, selectedSurveyArea])

  const [mutate] = useMutation(DELETE_SURVEY_AREA)
  return (
    <FormLayout
      addBtnText="Survey Area"
      title="Survey areas"
      className="em-survey-area-list"
      onAdd={() => {
        const newItem = {
          id: `vt-${generateId()}`,
          name: "New Survey Area",
          codename: uniqueId(),
        }

        onAdd("surveyAreas", newItem)
        setSelectedSurveyArea(newItem)
      }}
      header={
        <div className="flex">
          <StaticSelector
            renderText={item =>
              item?.name
                ? `${item.name} (${item.codename})`
                : "Select Survey Area"
            }
            value={selectedSurveyArea}
            onChange={(_, value) => setSelectedSurveyArea(value)}
            className="mb-0"
            searchVector={["name", "codename"]}
            items={surveyAreas}
            labelElement="codename"
          />
          {selectedSurveyArea?.id &&
          !selectedSurveyArea?.id?.startsWith("vt") ? (
            <CustomButton
              onClick={() =>
                mutate({
                  variables: {
                    ids: [selectedSurveyArea?.id],
                  },
                  onCompleted() {
                    const deletedIndex = surveyAreas.findIndex(
                      item => item.id === selectedSurveyArea?.id
                    )
                    onRemove("surveyAreas", deletedIndex, true)
                    setSelectedSurveyArea(null)
                  },
                })
              }
              className="ml-3"
              minimal
              icon="trash"
              intent="danger"
            />
          ) : null}
        </div>
      }
    >
      <FormController source={surveyAreas} onChange={onChange}>
        {surveyAreas?.map((s, idx) => (
          <SurveyAreaRegistration
            area={s}
            key={s.id}
            index={idx}
            selectedArea={selectedSurveyArea}
          />
        ))}
      </FormController>
    </FormLayout>
  )
}

export default DCSurveyAreaList
